module.exports = __webpack_public_path__ + "static/media/kampung-tengah.c66b6855.png";